import { makeActionCreator } from '../../../../utilities'
import { CardioConstants } from './cardio.constants'

export const setCvTemp = makeActionCreator(CardioConstants.SET_CVTEMP, 'cvTemp')
export const setCvTempDegrees = makeActionCreator(CardioConstants.SET_CVTEMPDEGREES, 'cvTempDegrees')
export const setCvTempMethod = makeActionCreator(CardioConstants.SET_CVTEMPMETHOD, 'cvTempMethod')
export const setCvJvd = makeActionCreator(CardioConstants.SET_CVJVD, 'cvJvd')
export const setCvCapRefill = makeActionCreator(CardioConstants.SET_CVCAPREFILL, 'cvCapRefill')
export const setCvEdema = makeActionCreator(CardioConstants.SET_CVEDEMA, 'cvEdema')
export const setCvComments = makeActionCreator(CardioConstants.SET_CVCOMMENTS, 'cvComments')
export const setCvArt = makeActionCreator(CardioConstants.SET_CVART, 'cvArt')
export const setCvSwan = makeActionCreator(CardioConstants.SET_CVSWAN, 'cvSwan')
export const setPrCvAssess = makeActionCreator(CardioConstants.SET_PRCVASSESS, 'prCvAssess')
export const setType = makeActionCreator(CardioConstants.SET_TYPE, 'pmType')
export const setRate = makeActionCreator(CardioConstants.SET_RATE, 'rate')
export const setMa = makeActionCreator(CardioConstants.SET_MA, 'ma')
export const setPmMode = makeActionCreator(CardioConstants.SET_PMMODE, 'pmMode')
export const saveCardio = makeActionCreator(CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO)
export const saveInitialAssessmentCardioNabc = makeActionCreator(
  CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO_NABC,
  'prNabc'
)
export const saveInitialAssessmentCardiPrPm = makeActionCreator(
  CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO_PRPM,
  'prPm'
)
export const resetInitialAssessmentCardioState = makeActionCreator(CardioConstants.RESET_CARDIO_STATE)
export const resetPacemaker = makeActionCreator(CardioConstants.RESET_PACEMAKER)
export const resetInvasiveMonitoring = makeActionCreator(CardioConstants.RESET_INVASIVE_MONITORING)
